export default function generateMonolithicClassName(style, prefix) {
  if (style.className) {
    var name = prefix + style.className;
    delete style.className;
    return name;
  }

  var stringified = JSON.stringify(style);
  var val = 5381;
  var i = stringified.length;

  while (i) {
    val = val * 33 ^ stringified.charCodeAt(--i);
  }

  return prefix + (val >>> 0).toString(36);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-utils/es/generateMonolithicClassName.js
// module id = 700
// module chunks = 0